import type { RefObject } from 'react';
import { createContext } from 'react';

export const AppContext = createContext<{
  topRef: RefObject<HTMLElement | null> | null,
}>({
  topRef: null,
});
